'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = uid;
var now = +new Date();
var index = 0;

function uid() {
  return 'rc-upload-' + now + '-' + ++index;
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-upload/lib/uid.js
 ** module id = 135
 ** module chunks = 0
 **/